import {
  type OrderItem,
  type Project,
  type Reward as RawReward,
  type Variant as RawVariant,
} from '@owl-nest/api-client/latest'
import { Reward } from './reward'
import { Variant } from './variant'

export function isReward(item: RawReward | RawVariant): item is RawReward {
  return !('parent' in item)
}

export function getReward<PROJECT_EXTRA_FIELDS extends string = ''>(
  orderItem: OrderItem<any>,
  project: Project<PROJECT_EXTRA_FIELDS>,
): Reward<PROJECT_EXTRA_FIELDS> | undefined {
  const rewardData = orderItem.reward
  if (isReward(rewardData)) {
    return Reward(rewardData, project)
  }
  if (rewardData.parent) {
    return Reward(rewardData.parent, project)
  }
}

export function getVariant<PROJECT_EXTRA_FIELDS extends string = ''>(
  orderItem: OrderItem,
  project: Project<PROJECT_EXTRA_FIELDS>,
): Variant<PROJECT_EXTRA_FIELDS> | undefined {
  const rewardData = orderItem.reward
  if (isReward(rewardData)) {
    return undefined
  }
  if (rewardData.parent) {
    return Variant(rewardData, Reward(rewardData.parent, project))
  }
}
